import { buildOauthStateString } from "@WombatTechnology/nitte-time-lib"
export const auth = () => {
  const stateString = buildOauthStateString(true, "text-gen", null, "")
  window.location.href = `${
    import.meta.env.VITE_APP_CLOUD_FUNCTION_URL
  }/internal_api/auth/google?state=${stateString}`
}

export const authMs = () => {
  const stateString = buildOauthStateString(true, "text-gen", null, "")
  window.location.href = `${
    import.meta.env.VITE_APP_CLOUD_FUNCTION_URL
  }/internal_api/auth/microsoft?state=${stateString}`
}
